import React, { Component } from 'react';
import { FullscreenImage } from '../components/FullscreenImage';
import options from "../containers/MusicPlayerOptions";
import SocialIcon from '../components/SocialIcon';
import NavMenu from '../components/NavMenu';

class Contact extends Component {
  constructor () {
    super();

    this.state = {
      musicParams: options,
    }
  }

    componentDidMount() {
    // Lock page scroll for full-screen hero
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    // Restore scroll when leaving page
    document.body.style.overflow = '';
  }

  render() {
    const { musicParams } = this.state;
    return (
      <FullscreenImage image="/images/HueWeb.Contact.ShatterMan.jpg">
          <NavMenu menuList={this.props.menuList} musicParams={musicParams} />
          <div className='flex object-center justify-center items-center self-auto w-100 h-100 md:mx-auto'>
            <div className="mt-2 mb-24 p-8 sm:w-2/3 md:w-1/2 max-w-md">
              <h1 className="visible mx-auto w-full text-white font-thin text-center pb-12 tracking-wide md:mt-32">CONTACT</h1>
              
              {/* Email */}
              <div className="text-center mb-6">
                <a 
                  href="mailto:hue@stevenhue.com" 
                  className="text-white text-xl font-thin hover:text-gray-300 transition-colors duration-200"
                >
                  hue[at]stevenhue[dot]com
                </a>
              </div>

              {/* Links - Vertical Stack */}
      
                <div className="flex flex-col items-center space-y-4 sm:space-y-3 md:space-y-4">

                <SocialIcon route="https://stevenhue.bandcamp.com/releases" imgSrc='images/bc_icon.png' />
                
                <SocialIcon route="https://open.spotify.com/artist/0MBxrJpZbYi4vxhIMnknUd" imgSrc='images/spotify_icon.png' />

                <SocialIcon route="https://music.apple.com/artist/steven-hue/1590270424" imgSrc='images/apple-music_icon.png' />

                <SocialIcon route="https://www.youtube.com/@steven_hue" imgSrc='images/youtube_icon.png' />

                <SocialIcon route="https://soundcloud.com/steven_hue" imgSrc='images/sc_icon.png' />

                <SocialIcon route="https://instagram.com/stevenhue.music" imgSrc='images/instagram_icon.png' />

                <SocialIcon route="https://twitter.com/steven_hue" imgSrc='images/twit_icon.png' />

              </div>
          </div>
        </div>
      </FullscreenImage>
    );
  }
}

export default Contact;